import { faGithub, faWordpressSimple} from '@fortawesome/free-brands-svg-icons'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'

const services = [
  {
    id:1,
    name:"Web Development",
    description:"Seeking for cost-effective Web Design & Web Development Services?",
    icon:faGithub
  },
  {
    id:2,
    name:"Wordpress",
    description:"Complete setup & designing of Wordpress Website for your Business",
    icon:faWordpressSimple
  },
  {
    id:3,
    name:"Affiliate Marketing",
    description:"Take consultancy and promote your campaigns on Hungama Deal",
    icon:faLightbulb
  },
];

export default services;
